
import React, { useEffect } from 'react';

const ShippingDelivery = () => {
    return (
        <>
            <div className="container-fluid contact mt-3">
                <div className="row">
                    <div className="col-10 mx-auto">
                        <div className="row">
                            <div className="col-md-12 mt-1">
                                {/* <Alert severity="info">
                                    {'TERMS STATEMENT'}<br />
                                    {'Datum: 09-DEC-2021'}
                                </Alert> */}
                            </div>
                            <div className="col-md-10 mt-5 fontStyle fontStyleTerms">
                                <h2>Shipping and Delivery Policy</h2>

                                <p>At Kaipsool Pharmatech, we focus on providing valuable information about the availability of medicines and discounts at nearby medical shops, as well as facilitating event ticket purchases. Since we do not physically deliver or ship products, this policy explains our approach.</p>

                                <h5 className="mt-4 mb-3">Medicines and Medical Products:</h5>
                                <ol>
                                    <li>Informational Platform: Kaipsool Pharmatech acts solely as an informational platform. We do not handle or deliver medicines or medical products. Our platform connects you with nearby medical shops where you can inquire about availability and discounts.</li>
                                    <li>Direct Contact with Medical Stores: To purchase medicines or medical products, you must contact the medical stores directly. We provide their contact details and location information for your convenience.</li>
                                </ol>  

                                <h5 className="mt-4 mb-3">Refund and Cancellation:</h5>
                                <ol>
                                    <li>Ticket Purchase: Kaipsool Pharmatech offers event tickets for various pharmaceutical events, health camps, and seminars. Users can purchase tickets for these events directly through our platform.</li>
                                    <li>E-Tickets: Event tickets purchased through our platform are in electronic (e-ticket) format. These tickets will be sent to your registered email address for access.</li>
                                    <li>Ticket Confirmation: After purchasing an event ticket, you will receive a confirmation email with your e-ticket attached. Please ensure that you check your email for this confirmation.</li>
                                    <li>Event Entry: To attend the event, present your e-ticket (either printed or displayed on your mobile device) at the event venue, as specified in the event details.</li>
                                </ol>  

                                <h5 className="mt-4 mb-3">Refund and Cancellation:</h5>
                                <ul>
                                    <li>Please refer to our "Cancellation and Refund Policy" for information regarding the cancellation and refund procedures for event tickets.</li>
                                </ul>                         
                                <br /><br />
                                

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ShippingDelivery
